module.exports = __webpack_public_path__ + "images/3be45c1443ce9da49c71abd9e7c422f8-hercules_logo.png";